
    import { NgModule } from '@angular/core';
    import { Routes, RouterModule } from '@angular/router';

    const routes: Routes = [
      {
      path: '',
      loadChildren: () => import('./pages/info-datos/info-datos.module').then(m => m.InfoDatosModule)
    }
    ];

    @NgModule({
      imports: [ RouterModule.forChild(routes) ],
      exports: [ RouterModule ]
    })
    export class DatosRoutingModule { }
    